import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Box from '@mui/joy/Box';
import CircularProgress from '@mui/joy/CircularProgress';
import { useAuth } from '../auth/AuthContext';

const ProtectedRoute: React.FC = () => {
  const { isBootstrapping, isAuthenticated } = useAuth();
  if (isBootstrapping) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          bgcolor: 'background.body',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
